export default {
	STANDARD: 'STANDARD', //ze słownika
	NOT_APPLICABLE: 'NOT_APPLICABLE', //nie dotyczy
	EXEMPTED: 'EXEMPTED', //zwolniony  = value null
	REVERSED: 'REVERSED', //odwrócony  = value null
	MIXED: 'MIXED', //mieszany, value null, wpisujemy netto i brutto ręcznie
	OTHER: 'OTHER', //spoza słownika wartość wpisywana recznie, brutto obliczmy
}